(() => {
  const bind = () => document.querySelectorAll('[data-vg-menu]').forEach(menu => {
    if (menu.dataset.vgAccessible) return;
    menu.dataset.vgAccessible = 'true';
    const toggle = menu.querySelector('.vg-menu__toggle');
    const panel = menu.querySelector('.vg-menu__panel');
    const close = () => { menu.open = false; toggle.focus(); };
    menu.addEventListener('toggle', () => {
      toggle.setAttribute('aria-expanded', String(menu.open));
      if (menu.open) panel.querySelector('[data-vg-close]')?.focus();
    });
    panel.querySelector('[data-vg-close]')?.addEventListener('click', close);
    menu.addEventListener('keydown', event => {
      if (!menu.open) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href]:not([tabindex="-1"]),button,summary,select,input')].filter(el => el.getClientRects().length && !el.disabled);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
